import React from 'react';
import { useTranslation } from 'react-i18next';

// API Base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'bn' ? 'en' : 'bn';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);

    // Optionally save to backend
    saveLanguagePreference(newLang);
  };

  const saveLanguagePreference = async (lang: string) => {
    try {
      await fetch(`${API_BASE_URL}/user-preferences/language/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ language: lang }),
      });
    } catch (error) {
      console.error('Failed to save language preference:', error);
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className="language-switcher"
    >
      {i18n.language === 'bn' ? 'English' : 'বাংলা'}
    </button>
  );
};

export default LanguageSwitcher;
